import React, { Component } from 'react';
import { ACCESS_TOKEN } from '../../util/Constants';
import * as AuthRepository from 'repository/auth/AuthRepository';
import * as UserRepository from 'repository/user/UserRepository';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { Form, Input, Spin, message, Modal, notification } from 'antd';
import colors from 'components/Buttons/colors';
import { LoadingOutlined } from '@ant-design/icons';
import { MdPerson, MdPassword, MdEmail } from 'react-icons/md';
import { LuCalendarCheck2 } from 'react-icons/lu';
import ButtonPrimary from 'components/Buttons/ButtonPrimary';

const FormItem = Form.Item;

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      modalVisible: false,
      modalEmail: '',
      loading: false,
      emailError: false,
    };
  }

  validateEmail(e) {
    /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(e)
      ? this.setState({ emailError: null }, function () {
          return true;
        })
      : this.setState(
          {
            emailError: (
              <small className="text-danger">El formato de la dirección de correo electronico no es valido.</small>
            ),
          },
          function () {
            return false;
          }
        );
  }

  async resetPassword() {
    const isEmailValid =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
        this.state.modalEmail
      );

    if (!isEmailValid) {
      this.setState({
        emailError: (
          <small className="text-danger">El formato de la dirección de correo electronico no es valido.</small>
        ),
      });
      return;
    }

    this.setState({ loading: true, modalVisible: false });
    try {
      var pathVariables = this.props.history.location.pathname.split('/');
      var center;
      if (pathVariables[pathVariables.length - 1] === 'login') center = 'nexotech';
      else center = pathVariables[pathVariables.length - 1];
      await UserRepository.resetPassword(this.state.modalEmail, center);

      notification['success']({
        message: 'ZinkinData Portal',
        description: 'La nueva contraseña se ha enviado a su correo electronico.',
      });

      this.setState({ modalLicensePlate: '', modalEmail: '', emailError: null });
    } catch (error) {
      notification['error']({
        message: 'ZinkinData Portal',
        description: error.message,
      });
    }
    this.setState({ loading: false });
  }

  setModalVisible(modalVisible) {
    this.setState({
      modalVisible,
    });
  }

  render() {
    const handleSubmit = (values) => {
      this.setState({ loading: true });
      var pathVariables = this.props.history.location.pathname.split('/');
      var center;
      if (pathVariables[pathVariables.length - 1] === 'login') center = 'nexotech';
      else center = pathVariables[pathVariables.length - 1];
      var request = {
        username: `${values.username}@${center}`,
        password: values.password,
      };
      AuthRepository.login(request)
        .then((response) => {
          switch (response.status) {
            case 401:
              response.text().then((text) => {
                let number = text.charAt(text.length - 2);
                let attempts = 4 - number;
                if (isNaN(attempts)) {
                  notification['error']({
                    message: 'Credenciales incorrectas',
                    description: 'Credenciales incorrectas. Vuelve a intentarlo.',
                  });
                } else {
                  if (attempts > 0) {
                    notification['error']({
                      message: 'Credenciales incorrectas',
                      description: 'Intentos restantes antes del bloqueo: ' + attempts,
                    });
                  } else {
                    notification['error']({
                      message: 'Usuario bloqueado',
                      description: 'Contacte con un administrador.',
                    });
                  }
                }
              });
              this.setState({ loading: false });
              break;
            case 403:
              notification['error']({
                message: 'Usuario bloqueado',
                description: 'Contacte con un administrador.',
              });
              this.setState({ loading: false });
              break;
            case 500:
              notification['error']({
                message: 'ZinkinData Portal',
                description: 'Error interno del servidor.',
              });
              this.setState({ loading: false });
              break;
            default:
              localStorage.setItem(ACCESS_TOKEN, response.accessToken);
              UserRepository.getCurrentUser()
                .then((responseUser) => {
                  if (responseUser.firstLogin) {
                    this.props.onChangePassword(
                      'change-password-page.first-login.title',
                      'change-password-page.first-login.description'
                    );
                  } else if (responseUser.mfa) {
                    this.props.onMfaVerify(responseUser.id, responseUser.email, response.lastAccessAt);
                  } else if (responseUser.passwordExpired) {
                    this.props.onChangePassword(
                      'change-password-page.password-expire.title',
                      'change-password-page.password-expire.description'
                    );
                  } else {
                    this.props.onLogin();
                    if (response.lastAccessAt !== null) {
                      notification['info']({
                        message: this.props.t('login.last-access'),
                        description: moment(response.lastAccessAt).format('DD-MM-YYYY HH:mm:ss'),
                        icon: <LuCalendarCheck2 style={{ color: '#108ee9' }} />,
                        duration: 5,
                      });
                    }
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
              break;
          }
        })
        .catch((error) => {
          this.setState({ errors: { global: error.message } });
          this.setState({ loading: false });
        });
    };

    const iconStyles = { fontSize: 22, color: '#0085cb' };
    const loadingIcon = <LoadingOutlined />;

    return (
      <Spin
        spinning={this.state.loading}
        indicator={loadingIcon}
      >
        <Form
          onFinish={handleSubmit}
          className="login-form"
        >
          {this.state.errors.global
            ? (message.error('Error: ' + this.state.errors.global), this.setState({ errors: { global: false } }))
            : ''}
          <FormItem
            name="username"
            rules={[
              {
                required: true,
                message: 'Introduce el nombre de usuario, por favor',
              },
            ]}
          >
            <Input
              suffix={<MdPerson style={iconStyles} />}
              size="large"
              placeholder="Usuario"
              name="username"
            />
          </FormItem>
          <FormItem
            name="password"
            rules={[
              {
                required: true,
                message: 'Introduce la contraseña, por favor',
              },
            ]}
          >
            <Input
              size="large"
              type="password"
              placeholder="Contraseña"
              name="password"
              suffix={<MdPassword style={iconStyles} />}
            />
          </FormItem>
          <FormItem>
            <ButtonPrimary
              color="blue"
              htmlType="submit"
              size="large"
              block
              shape="round"
            >
              Login
            </ButtonPrimary>
            <p style={{ textAlign: 'center', marginTop: '20px', marginBottom: '5px' }}>
              <span
                className="pass-recovery"
                onClick={() => {
                  this.setModalVisible(true);
                }}
                style={{ color: '#0064ad' }}
              >
                Forgot your password?
              </span>
            </p>
          </FormItem>
        </Form>
        <Modal
          title="Forgot your password?"
          wrapClassName="vertical-center-modal"
          open={this.state.modalVisible}
          onOk={() => this.resetPassword()}
          onCancel={() => this.setModalVisible(false)}
          okText="Recuperar"
          cancelText="Cancelar"
          className="forgotPass"
          okButtonProps={{ style: { backgroundColor: colors.blue.main, borderColor: colors.blue.main } }}
        >
          <div>
            <FormItem>
              {
                <div>
                  <Input
                    suffix={<MdEmail />}
                    size="large"
                    placeholder="Email"
                    name="email"
                    value={this.state.modalEmail}
                    onChange={(event) => {
                      this.setState({ modalEmail: event.target.value });
                    }}
                  />
                  {this.state.emailError}
                </div>
              }
            </FormItem>
          </div>
        </Modal>
      </Spin>
    );
  }
}

export default withTranslation('common')(LoginForm);
